export const pages = {
    billing: 'billing',
    plans: 'plans',
};

export const actions = {
    openPage: 'open_page',
    openPlanBySystem: 'open_plan_by_system',
    openPlanByUser: 'open_plan_by_user',
    confirmPlan: 'confirm_plan',
    closePlan: 'close_plan',
    addFundsInPlan: 'add_funds_in_plan',
    addFunds: 'add_funds',
    changePlan: 'change_plan',
    contactSales: 'contact_sales',
    openChangeCardPopup: 'open_change_card_popup',
    closeChangeCardPopup: 'close_change_card_popup',
    openFormForAddingNewCard: 'open_form_for_adding_new_card',
    changeCardForPlan: 'change_card_for_plan',
    removeCard: 'remove_card',
    cancelPlan: 'cancel_plan',
    resumePlan: 'resume_plan',
};